import classNames from 'classnames'

import type { ReactElement } from 'react'
import type { Props as RefinementListProps } from '~/components/Algolia/RefinementList'

import AlgoliaClearRefinements from '~/components/Algolia/ClearRefinements'
import AlgoliaRefinementList from '~/components/Algolia/RefinementList'

import './styles.scss'

interface Props {
  className?: string
  refinements: RefinementListProps[]
}

const Refinements = ({ className, refinements }: Props): ReactElement => {
  return (
    <div className={classNames('table-refinements-component', className)}>
      <AlgoliaClearRefinements />
      {refinements.map((props, index) => (
        <div className="table-refinements-component__refinement" key={`refinement-list-${index}`}>
          <AlgoliaRefinementList {...props} />
        </div>
      ))}
    </div>
  )
}

export default Refinements
